import { render, staticRenderFns } from "./breeder-add-component.vue?vue&type=template&id=d3356594&scoped=true&lang=pug"
import script from "./breeder-add-component.js?vue&type=script&lang=js&external"
export * from "./breeder-add-component.js?vue&type=script&lang=js&external"
import style0 from "./breeder-add-component.vue?vue&type=style&index=0&id=d3356594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3356594",
  null
  
)

export default component.exports